import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, Clock, ArrowUpRight } from "lucide-react";
import Logo from "./Logo";
import { CONTACT, NAV_LINKS } from "../lib/brand";

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative z-10 bg-forest text-cream-100">
      <div className="mx-auto max-w-[1400px] px-5 py-20 md:px-10 md:py-28">
        <div className="grid gap-14 lg:grid-cols-[1.3fr_1fr_1.1fr]">
          <div>
            <div className="mb-6 w-fit">
              <span className="block font-display text-5xl font-semibold leading-none tracking-[0.1em]">VENYA</span>
              <div className="mt-2 flex w-full justify-between font-display text-xs font-medium text-gold">
                {"TRADE ENTERPRISES".split("").map((c, i) => (
                  <span key={i}>{c === " " ? "\u00A0" : c}</span>
                ))}
              </div>
            </div>
            <p className="max-w-sm font-display text-2xl italic leading-snug text-cream-100/90">
              {CONTACT.tagline}
            </p>
            <p className="mt-6 max-w-sm text-sm text-cream-100/60">
              A subsidiary of {CONTACT.parent}. Wholesale · Import · Export of fresh
              Indian, exotic and imported fruit.
            </p>
          </div>

          <div>
            <p className="mb-6 text-sm font-medium text-gold">Navigate</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="group inline-flex items-center gap-1.5 text-cream-100/80 transition-colors duration-300 hover:text-gold"
                  >
                    {l.label}
                    <ArrowUpRight className="h-3.5 w-3.5 opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="mb-6 text-sm font-medium text-gold">The Desk</p>
            <ul className="space-y-5 text-sm">
              <li className="flex gap-3">
                <MapPin className="mt-0.5 h-4 w-4 flex-none text-gold" />
                <span className="text-cream-100/80">{CONTACT.office}</span>
              </li>
              <li className="flex gap-3">
                <Mail className="mt-0.5 h-4 w-4 flex-none text-gold" />
                <a href={`mailto:${CONTACT.email}`} className="text-cream-100/80 hover:text-gold">
                  {CONTACT.email}
                </a>
              </li>
              <li className="flex gap-3">
                <Phone className="mt-0.5 h-4 w-4 flex-none text-gold" />
                <a href={`tel:${CONTACT.phoneHref}`} className="text-cream-100/80 hover:text-gold">
                  {CONTACT.phone}
                </a>
              </li>
              <li className="flex gap-3">
                <Clock className="mt-0.5 h-4 w-4 flex-none text-gold" />
                <span className="text-cream-100/80">{CONTACT.hours}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col justify-between gap-4 border-t border-cream-100/15 pt-8 text-xs text-cream-100/50 sm:flex-row">
          <span>© {new Date().getFullYear()} Venya Trade Enterprises. All rights reserved.</span>
          <span className="text-cream-100/40 tracking-wide" style={{ fontSize: "0.6rem" }}>
            Two generations of trade, under one roof
          </span>
        </div>
      </div>
    </footer>
  );
}
